
export const MOBILE_BREAKPOINT = 768;

export const BREAKPOINTS = {
  mobile: 767,
  tablet: 991,
  desktop: 1200,
  largeDesktop: 1440
};

export const ANIMATION = {
  fast: 200,
  normal: 300,
  slow: 500
};

export const Z_INDEX = {
  base: 1,
  overlay: 10,
  modal: 20,
  tooltip: 30,
  header: 100,
  dropdown: 200
};

// The Keylight API
// export const API_BASE = 'http://localhost:3000';
// export const API_BASE = 'https://keylight-api-pr-9.onrender.com';
export const API_BASE = 'https://keylight-api.onrender.com';

// Three components submit a lead, so this one lives beside the base rather
// than being written out in each of them.
export const LEADS_API = `${API_BASE}/api/leads`;

// The elevation catalog the combinator panels read.
export const ELEVATIONS_API = `${API_BASE}/api/elevations`;

export const MAPBOX_TOKEN =
  'pk.eyJ1IjoiZGVubmlzaG9tZWJhc2UiLCJhIjoiY21mNXk4cHk3MGI0ZjJscHdqcGptczI5dCJ9.354hWPfzlWtMSCYk0UEZOA';

// The Webflow wrap around a collection index list (listings, neighborhoods).
// The class is Webflow's and a re-export can rename it at any time, so every
// consumer — each page's fail-open reveal, the components' wrapSelector
// overrides, and the page test fixtures — reads this one definition.
export const COLLECTION_WRAP_SELECTOR = '.listing-entity-collection';

export const STORAGE_KEYS = {
  theme: 'app_theme',
  token: 'auth_token',
  user: 'user_data'
};

export const LIMITS = {
  maxUploadSize: 10 * 1024 * 1024, // 10MB
  maxTextLength: 500,
  maxRetries: 3
};

export const DEFAULTS = {
  theme: 'light',
  language: 'en',
  currency: 'USD',
  pageSize: 20
};

export type Theme = 'light' | 'dark' | 'system';

export type Language = 'en' | 'es' | 'fr' | 'de' | 'ja';

export type Currency = 'USD' | 'EUR' | 'GBP' | 'JPY' | 'CAD';